import axios from '../../plugins/axios';
import { Message } from 'element-ui';

export const productCategories_module = {
    state: ()=>({
        pending: false,
        loadingMore: false,
        data: {
            current_page: 1,
            data: [],
            last_page: null,
            searchedKeyword:'',
            filter:{
                status:[],
                indexed:[],
                type:[],
            },
            allFilters:[],
        },
        message: null,
        success: null,
        error: null
    }),
    mutations: {
        fetch_categories_request(state, loadingType){

            if(loadingType == 'new'){

                state.pending = true;

            }else if(loadingType == 'more'){

                state.loadingMore = true;

            }

        },
        fetch_categories_success(state, payload){

            if(payload.loadData === 'new'){

                state.data.data = payload.categories.data;

            }else if(payload.loadData === 'more'){

                state.data.data.push(...payload.categories.data);

            }

            state.data.current_page = payload.categories.current_page;
            state.data.last_page = payload.categories.last_page;
            state.pending = false;
            state.loadingMore = false;
            state.success = true;
            state.error = null;
            state.message = payload.message;

        },
        fetch_categories_failure(state, payload){

            if(this.state.productCategories_module.data.searchedKeyword.length > 0){

                state.data.data = [];

            }

            state.pending = false;
            state.loadingMore = false;
            state.success = false;
            state.error = payload.error;
            state.message = payload.message;
            
        },
        add_categories_list(state,payload){

            state.data.data.unshift(payload);

        },
        update_categories_list(state,payload){

            let categoryIndex = state.data.data.findIndex((category) => category.id == payload.category.id)

            if(categoryIndex != -1){

                state.data.data[categoryIndex] = payload.category;

            }

            if(payload.category.isActive == 0){

                state.data.data.forEach((category)=>{ 

                    if(category.parent_id && (category.parent_id == payload.category.id)){

                        category.parent_id = null;

                        category.parents = [];

                    }

                });

            }

            state.data.data.forEach((category) => { 

                if(category.parent_id && (category.parent_id == payload.category.id)){
                
                    category.parents[0].name = payload.category.name;
                
                }

            });

        },
        update_categories_status(state,payload){

            state.data.data[payload.index].isActive = payload.updatedCategory.isActive;

            if(payload.updatedCategory.isActive == 0){

                state.data.data.forEach((category)=>{ 

                    if(category.parent_id && (category.parent_id == payload.updatedCategory.id)){

                        category.parent_id = null;

                        category.parents = [];

                    }

                });

            }

        },
        delete_categories_list(state,payload){

            let tempCategory = state.data.data[payload]

            state.data.data.forEach((category)=>{ 

                if(category.parent_id && (category.parent_id == tempCategory.id)){

                    category.parent_id = null;

                    category.parents = [];

                }

            });

            state.data.data.splice(payload,1);

        },
        categories_bulk_action(state,payload){
            
            if(payload.action == 'delete'){

                state.data.data = state.data.data.filter((category)=>{

                    if(!payload.listIds.includes(category.id)){

                        return category;

                    }else{

                        if(category.created_by_user == null){

                            return category;

                        }

                    }
                    
                });

            }else if(payload.action == 'statusChange'){

                state.data.data.forEach((category) =>{

                    if(payload.listIds.includes(category.id)){

                        category.isActive = payload.status;

                    }
                    if(payload.listIds.includes(category.parent_id) && payload.status == 0){

                        category.parent_id = null;

                        category.parents = [];

                    }

                });

            }else if(payload.action == 'isIndexed'){

                state.data.data.forEach((category) => {

                    if(payload.listIds.includes(category.id)){

                        category.isIndexed = payload.indexed;

                    }

                });

            }
            
        },
        update_searched_keyword(state,payload){

            state.data.searchedKeyword = payload.keyword;

        },
        remove_searched_keyword(state){

            state.data.allFilters = []

            state.data.searchedKeyword = '';

        },
        update_category_filters(state,payload){

            state.data.filter.status = payload.status
            state.data.filter.indexed = payload.indexed
            state.data.filter.type = payload.type

        },
        update_category_all_filters(state,payload){

            state.data.allFilters = payload

        },
        remove_category_filters(state){

            state.data.filter.status = []
            state.data.filter.type = []
            state.data.filter.indexed = []

        },
        CLEAR_MODULE(state){

            state.pending = false;
            state.loadingMore = false;
            state.message = null;
            state.success = null;
            state.error = null;

            state.data.current_page = 1;
            state.data.data = [];
            state.data.last_page = null;
            state.data.searchedKeyword= '';
            state.data.filter = {
                status:[],
                indexed:[],
                type:[],
            }
            state.data.allFilters = []

        }
    },
    actions:{
        async fetchProductCategoriesRequest({commit},{size, page, loadData}){

            commit('fetch_categories_request',loadData);

            let status = this.state.productCategories_module.data.filter.status[0];
            let indexed = this.state.productCategories_module.data.filter.indexed[0];
            let type = this.state.productCategories_module.data.filter.type[0];
            const searchedKeyword = this.state.productCategories_module.data.searchedKeyword;

            try{
                let res = await axios.get('/getCategories',{
                    params:{
                        search: searchedKeyword.length > 0 ? searchedKeyword : null,
                        offset: size,
                        page: page,
                        active: status ? status == 'active' ? 1 : 0 : null,
                        indexed: indexed ? indexed == 'indexed' ? 1 : 0 : null,
                        type: type ? type : null,
                        with: 'parent,available_products'
                    }
                });
                if(res.data.status_code == '1003'){

                    res.data.loadData = loadData;

                    commit('fetch_categories_success', res.data);

                }
            }catch(ex){

                Message({
                    type: 'error',
                    showClose: true,
                    message: ex.response ? ex.response.data.message : ex.message,
                });

                commit('fetch_categories_failure', {error: ex, message: ex});

            }
        }
    },
    getters: {
        categories(state){

            return state.data.data;

        },
        keyword(state){

            return state.data.searchedKeyword;

        },
        isPending(state){

            return state.pending;

        },
        isLoadingMore(state){

            return state.loadingMore;

        },
        filters(state){

            return state.data.filter;

        },
        allFilters(state){

            return state.data.allFilters;

        },
        currentPage(state){

            return state.data.current_page;

        },
        lastPage(state){

            return state.data.last_page;

        },
        message(state){
            
            return state.message;

        },
        error:(state)=>state.error
    }
}